<form class="cupom-form" novalidate #frm="ngForm" (ngSubmit)="onSalvar()">
  <div class="ce-layout">

    <aside class="ce-lateral">
      <div class="ce-ticket" [class.ce-ticket--rascunho]="!cupom.codigo">
        <span class="ce-ticket-rotulo">{{ rotuloAlvo() }}</span>
        <strong class="ce-ticket-valor">{{ textoDesconto() }}</strong>
        <span class="ce-ticket-corte"></span>
        <button type="button" class="ce-ticket-codigo" (click)="copieCodigo()" [disabled]="!cupom.codigo"
                [title]="codigoCopiado ? 'Código copiado' : 'Copiar código'">
          <span>{{ cupom.codigo || 'CODIGO' }}</span>
          <i [class]="codigoCopiado ? 'fas fa-check' : 'far fa-copy'"></i>
        </button>
        <span class="ce-ticket-copiado" *ngIf="codigoCopiado">Código copiado</span>
        <ul class="ce-ticket-regras" *ngIf="regrasResumo().length">
          <li *ngFor="let regra of regrasResumo()">{{ regra }}</li>
        </ul>
      </div>

      <nav class="ce-nav">
        <button type="button" class="ce-nav-item" *ngFor="let s of secoes"
                [class.ativa]="secao === s.id" (click)="secao = s.id">
          <i class="{{ s.icone }}"></i>
          <span class="ce-nav-texto">
            <b class="ce-nav-titulo">{{ s.titulo }}</b>
            <b class="ce-nav-titulo-curto">{{ s.curto }}</b>
            <small>{{ resumoSecao(s.id) }}</small>
          </span>
          <span class="ce-nav-erro" *ngIf="frm.submitted && secaoComErro(s.id)" title="Tem campo a corrigir aqui"></span>
        </button>
      </nav>
    </aside>

    <div class="ce-conteudo">

      <!-- O DESCONTO -->
      <section class="ce-painel" [hidden]="secao !== 'desconto'">
        <header class="ce-painel-cabecalho">
          <h3>O desconto</h3>
          <p>O código que o cliente digita e o que ele ganha. Só com isto o cupom já funciona.</p>
        </header>

        <div class="ce-campo">
          <label for="codigo">Código</label>
          <div class="ce-codigo" [class.invalido]="codigo.invalid && (codigo.touched || frm.submitted)">
            <input id="codigo" name="codigo" type="text" minlength="5" pattern="^[a-zA-Z0-9]+$" required appAutoFocus
                   autocomplete="off" spellcheck="false" placeholder="Ex.: BEMVINDO10"
                   [(ngModel)]="cupom.codigo" #codigo="ngModel">
            <button type="button" class="ce-codigo-acao" (click)="copieCodigo()" [disabled]="!cupom.codigo">
              <i [class]="codigoCopiado ? 'fas fa-check' : 'far fa-copy'"></i> {{ codigoCopiado ? 'Copiado' : 'Copiar' }}
            </button>
            <button type="button" class="ce-codigo-acao" (click)="gereCodigoCupom()">
              <i class="fa fa-random"></i> Gerar
            </button>
          </div>
          <ng-container *ngIf="codigo.errors && (codigo.touched || frm.submitted)">
            <span class="ce-erro" *ngIf="codigo.errors.required">Informe um código.</span>
            <span class="ce-erro" *ngIf="codigo.errors.pattern">Use só letras e números, sem espaço.</span>
            <span class="ce-erro" *ngIf="codigo.errors.minlength">Mínimo de 5 caracteres.</span>
          </ng-container>
          <span class="ce-dica" *ngIf="!codigo.errors || !(codigo.touched || frm.submitted)">Letras e números, a partir de 5 caracteres.</span>
        </div>

        <div class="ce-campo">
          <label for="nome">Descrição</label>
          <input type="text" class="ce-input" autocomplete="off" id="nome" name="nome" required
                 placeholder="Ex.: Boas-vindas para novos clientes"
                 [class.invalido]="nome.invalid && (nome.touched || frm.submitted)"
                 [(ngModel)]="cupom.nome" #nome="ngModel"/>
          <span class="ce-erro" *ngIf="nome.errors?.required && (nome.touched || frm.submitted)">Dê um nome para achar o cupom depois.</span>
        </div>

        <div class="ce-campo">
          <span class="ce-rotulo">Tipo de desconto</span>
          <div class="ce-tipos">
            <label class="ce-tipo" *ngFor="let tipo of tiposDeCupoms" for="tipoCupom{{tipo}}"
                   [class.selecionado]="cupom.tipo === tipo" [class.desabilitado]="cupom.jaUtilizado">
              <input id="tipoCupom{{tipo}}" name="tipoCupom" type="radio" [value]="tipo" required
                     [(ngModel)]="cupom.tipo" [disabled]="cupom.jaUtilizado"/>
              <span class="ce-tipo-simbolo">{{ tipo === EnumTipoDeCupom.Valor ? 'R$' : '%' }}</span>
              <span class="ce-tipo-texto">
                <b>{{ tipo === EnumTipoDeCupom.Valor ? 'Valor fixo' : 'Percentual' }}</b>
                <small>{{ tipo === EnumTipoDeCupom.Valor ? 'Ex.: R$ 10 de desconto' : 'Ex.: 15% de desconto' }}</small>
              </span>
            </label>
          </div>
        </div>

        <div class="ce-linha">
          <div class="ce-campo" *ngIf="cupom.tipo === EnumTipoDeCupom.Valor">
            <label for="valor">Desconto</label>
            <kendo-numerictextbox [attr.type]="'number'" id="valor" name="valor" format="c2" [min]="0"
                                  [(ngModel)]="cupom.valor" #valor="ngModel" required>
            </kendo-numerictextbox>
            <span class="ce-erro" *ngIf="valor.invalid && frm.submitted">Informe o valor do desconto.</span>
          </div>

          <div class="ce-campo" *ngIf="cupom.tipo === EnumTipoDeCupom.Percentual">
            <label for="percentual">Desconto</label>
            <kendo-numerictextbox [attr.type]="'number'" id="percentual" name="percentual" [min]="1" [max]="100"
                                  [format]="obtenhaFormatoPercentual()"
                                  [(ngModel)]="cupom.percentual" #percentual="ngModel" required>
            </kendo-numerictextbox>
            <span class="ce-erro" *ngIf="percentual.invalid && frm.submitted">Informe um percentual de 1 a 100.</span>
          </div>
        </div>

        <div class="ce-campo">
          <span class="ce-rotulo">Desconto em</span>
          <div class="ce-alvos">
            <label class="ce-alvo" for="alvoProduto" [class.selecionado]="cupom.alvo === 'produto'" [class.desabilitado]="cupom.jaUtilizado">
              <input id="alvoProduto" name="alvo" type="radio" [value]="'produto'" required
                     [(ngModel)]="cupom.alvo" (ngModelChange)="alvoSeraProdutos()" [disabled]="cupom.jaUtilizado"/>
              <i class="fas fa-shopping-basket"></i>
              <b>Produtos</b>
              <small>Abate do valor dos itens</small>
            </label>
            <label class="ce-alvo" for="alvoTaxaEntrega" [class.selecionado]="cupom.alvo === 'taxaEntrega'" [class.desabilitado]="cupom.jaUtilizado">
              <input id="alvoTaxaEntrega" name="alvo" type="radio" [value]="'taxaEntrega'" required
                     [(ngModel)]="cupom.alvo" (ngModelChange)="alvoSeraTaxaEntrega()" [disabled]="cupom.jaUtilizado"/>
              <i class="fas fa-motorcycle"></i>
              <b>Taxa de entrega</b>
              <small>Abate do frete</small>
            </label>
            <label class="ce-alvo" for="alvoFidelidade" *ngIf="cupom.tipo === EnumTipoDeCupom.Percentual"
                   [class.selecionado]="cupom.alvo === 'fidelidade'" [class.desabilitado]="cupom.jaUtilizado">
              <input id="alvoFidelidade" name="alvo" type="radio" [value]="'fidelidade'" required
                     [(ngModel)]="cupom.alvo" (ngModelChange)="alvoSeraFidelidade()" [disabled]="cupom.jaUtilizado"/>
              <i class="fas fa-bolt"></i>
              <b>Turbinar cashback</b>
              <small>Aumenta o cashback do pedido</small>
            </label>
          </div>
          <span class="ce-dica" *ngIf="cupom.jaUtilizado">O cupom já foi usado, então o tipo e o alvo do desconto não mudam mais.</span>
        </div>

        <div class="ce-grupo" *ngIf="!cupom.brindeResgate || !(cupom.aplicarNaFidelidade || cupom.aplicarNaTaxaDeEntrega)">
          <label class="ce-opcao" for="selecionavel" *ngIf="!cupom.brindeResgate">
            <span class="ce-opcao-texto">
              <b>Mostrar na loja</b>
              <small>O cliente vê o cupom e aplica com um toque, sem digitar o código.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="selecionavel" name="selecionavel"
                   [(ngModel)]="cupom.selecionavel"/>
          </label>
          <label class="ce-opcao" for="naoPontuarFidelidade" *ngIf="!(cupom.aplicarNaFidelidade || cupom.aplicarNaTaxaDeEntrega)">
            <span class="ce-opcao-texto">
              <b>Não pontuar fidelidade</b>
              <small>Pedido com este cupom não soma pontos nem cashback.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="naoPontuarFidelidade" name="naoPontuarFidelidade"
                   [(ngModel)]="cupom.naoPontuarFidelidade"/>
          </label>
        </div>
      </section>

      <!-- QUEM PODE USAR -->
      <section class="ce-painel" [hidden]="secao !== 'quem'">
        <header class="ce-painel-cabecalho">
          <h3>Quem pode usar</h3>
          <p>Sem nada ligado, qualquer cliente usa o cupom.</p>
        </header>

        <div class="ce-grupo">
          <label class="ce-opcao" for="primeiraCompra">
            <span class="ce-opcao-texto">
              <b>Só na primeira compra</b>
              <small>Vale apenas para quem nunca pediu na loja.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="primeiraCompra" name="primeiraCompra"
                   [(ngModel)]="cupom.primeiraCompra"/>
          </label>
          <label class="ce-opcao" for="restrito">
            <span class="ce-opcao-texto">
              <b>Só uma lista de contatos</b>
              <small>Você escolhe os contatos depois, pela lista de cupons.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="restrito" name="restrito" [(ngModel)]="cupom.restrito"/>
          </label>
          <label class="ce-opcao" for="restritoContatoPerdido">
            <span class="ce-opcao-texto">
              <b>Só contatos perdidos</b>
              <small>Clientes que pararam de pedir.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="restritoContatoPerdido" name="restritoContatoPerdido"
                   [(ngModel)]="cupom.restritoContatoPerdido"/>
          </label>
          <label class="ce-opcao" for="aniversariantes">
            <span class="ce-opcao-texto">
              <b>Só aniversariantes</b>
              <small>Vale para quem faz aniversário no período.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="aniversariantes" name="aniversariantes"
                   [(ngModel)]="cupom.restritoAniversariantes"/>
          </label>
        </div>
      </section>

      <!-- EM QUAIS PEDIDOS -->
      <section class="ce-painel" [hidden]="secao !== 'pedidos'">
        <header class="ce-painel-cabecalho">
          <h3>Em quais pedidos</h3>
          <p>Tudo aqui é opcional. Sem nada definido, o cupom vale em qualquer pedido.</p>
        </header>

        <h4 class="ce-subtitulo">Valor mínimo</h4>
        <div class="ce-linha">
          <div class="ce-campo">
            <label for="valorMinimo">Pedido mínimo</label>
            <kendo-numerictextbox [attr.type]="'number'" id="valorMinimo" name="valorMinimo" format="c2" [min]="0"
                                  [(ngModel)]="cupom.valorMinimo">
            </kendo-numerictextbox>
            <span class="ce-dica">Deixe R$ 0,00 para não exigir.</span>
          </div>
        </div>
        <div class="ce-campo" *ngIf="cupom.valorMinimo">
          <label for="mensagemMinimo">Mensagem quando o pedido não atinge o mínimo</label>
          <textarea class="ce-input" id="mensagemMinimo" rows="2" name="mensagemMinimo"
                    [placeholder]="'Padrão: Valor mínimo do pedido para ativar esse cupom é ' + (cupom.valorMinimo | currency: 'BRL')"
                    [(ngModel)]="cupom.mensagemMinimo"></textarea>
        </div>

        <h4 class="ce-subtitulo">Canal e entrega</h4>
        <div class="ce-campo">
          <span class="ce-rotulo">Canal</span>
          <div class="ce-chips">
            <ng-container *ngFor="let e of escopos">
              <label class="ce-chip" for="escopo-{{e.valor}}" [class.selecionado]="(cupom.escopo || 'livre') === e.valor"
                     *ngIf="e.valor !== 'mesas' || !cupom.aplicarNaTaxaDeEntrega">
                <input id="escopo-{{e.valor}}" name="escopo" type="radio" [value]="e.valor" [(ngModel)]="cupom.escopo"/>
                {{ e.label }}
              </label>
            </ng-container>
          </div>
        </div>

        <div class="ce-campo" *ngIf="cupom.escopo !== 'mesas' && !cupom.aplicarNaTaxaDeEntrega">
          <span class="ce-rotulo">Entrega ou retirada</span>
          <div class="ce-chips">
            <label class="ce-chip" *ngFor="let f of formasEntrega" for="forma-{{f.valor || 'todas'}}"
                   [class.selecionado]="(cupom.formaEntrega || '') === f.valor">
              <input id="forma-{{f.valor || 'todas'}}" name="formaEntrega" type="radio" [value]="f.valor" [(ngModel)]="cupom.formaEntrega"/>
              {{ f.label }}
            </label>
          </div>
        </div>

        <h4 class="ce-subtitulo">Pagamento</h4>
        <div class="ce-campo">
          <label for="formasDePagamento">Formas de pagamento aceitas</label>
          <kendo-multiselect id="formasDePagamento" name="formasDePagamento"
                             [data]="formasDePagamento" placeholder="Todas"
                             textField="descricao" valueField="id"
                             [(ngModel)]="cupom.formasDePagamento" (valueChange)="alterouFormasPagamento()">
            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <span>{{ dataItem.descricao }}</span>
            </ng-template>
          </kendo-multiselect>
        </div>

        <h4 class="ce-subtitulo">Itens do carrinho</h4>
        <div class="ce-campo" *ngIf="tamanhosPizzas.length">
          <label>Só em pizzas do tamanho</label>
          <kendo-multiselect name="produtosTemplateTamanho"
                             [data]="tamanhosPizzas" [filterable]="false"
                             [textField]="'descricao'" [valueField]="'id'"
                             [(ngModel)]="cupom.produtosTemplateTamanho"
                             (change)="alterouComboProduto($event)"
                             placeholder="Todos os tamanhos">
          </kendo-multiselect>
        </div>

        <div class="ce-campo">
          <label>Exige item destas categorias no carrinho</label>
          <kendo-multiselect name="categorias"
                             [data]="categorias" [filterable]="true"
                             [textField]="'nome'" [valueField]="'id'"
                             [(ngModel)]="cupom.categorias"
                             (filterChange)="searchCategoria($event)"
                             placeholder="Nenhuma exigência">
          </kendo-multiselect>
        </div>

        <div class="ce-campo">
          <label>Exige estes produtos no carrinho</label>
          <kendo-multiselect name="produtos"
                             [data]="produtos" [filterable]="true"
                             [textField]="'descricao'" [valueField]="'id'"
                             [(ngModel)]="cupom.produtos"
                             (change)="alterouComboProduto($event)"
                             (filterChange)="search($event)"
                             (focus)="busquePrimeiraVez()"
                             [disabled]="cupom.brindeResgate"
                             placeholder="Digite para buscar">
          </kendo-multiselect>
        </div>

        <div class="ce-grupo"
             *ngIf="cupom.valorMinimo && (cupom.produtos?.length || cupom.categorias?.length || cupom.produtosTemplateTamanho?.length)">
          <label class="ce-opcao" for="produtoNaoComporMinimo" *ngIf="!cupom.brindeResgate">
            <span class="ce-opcao-texto">
              <b>Itens exigidos não contam no mínimo</b>
              <small>O pedido mínimo é calculado sem os itens escolhidos acima.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="produtoNaoComporMinimo" name="produtoNaoComporMinimo"
                   [(ngModel)]="cupom.produtoNaoComporMinimo" [disabled]="cupom.minimoApenasNoValorProduto"/>
          </label>
          <label class="ce-opcao" for="minimoApenasNoValorProduto">
            <span class="ce-opcao-texto">
              <b>Mínimo só com os itens exigidos</b>
              <small>Apenas os itens escolhidos acima somam para o pedido mínimo.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="minimoApenasNoValorProduto" name="minimoApenasNoValorProduto"
                   [(ngModel)]="cupom.minimoApenasNoValorProduto" [disabled]="cupom.produtoNaoComporMinimo"/>
          </label>
          <label class="ce-opcao" for="minimoApenasMesmoTamanho" *ngIf="cupom.produtosTemplateTamanho?.length">
            <span class="ce-opcao-texto">
              <b>Mínimo só com pizzas do mesmo tamanho</b>
              <small>Somam apenas as pizzas dos tamanhos escolhidos.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="minimoApenasMesmoTamanho" name="minimoApenasMesmoTamanho"
                   [(ngModel)]="cupom.minimoApenasMesmoTamanho"/>
          </label>
        </div>

        <h4 class="ce-subtitulo">Produtos em promoção</h4>
        <div class="ce-grupo">
          <label class="ce-opcao" for="naoAplicarProdutosComDesconto">
            <span class="ce-opcao-texto">
              <b>Não aplicar em produto já com desconto</b>
              <small>A partir do percentual de desconto que você informar.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="naoAplicarProdutosComDesconto" name="naoAplicarProdutosComDesconto"
                   [(ngModel)]="cupom.naoAplicarProdutosComDesconto"/>
          </label>
          <div class="ce-opcao ce-opcao--filha" *ngIf="cupom.naoAplicarProdutosComDesconto">
            <span class="ce-opcao-texto">
              <b>Desconto acima de</b>
              <small *ngIf="!(valorMaximoDescontoProduto.invalid && frm.submitted)">Produto com desconto maior que este fica de fora.</small>
              <ng-container *ngIf="valorMaximoDescontoProduto.invalid && frm.submitted">
                <span class="ce-erro" *ngIf="valorMaximoDescontoProduto.errors?.required">Informe o percentual.</span>
                <span class="ce-erro" *ngIf="valorMaximoDescontoProduto.errors?.minError">Mínimo {{ valorMaximoDescontoProduto.errors?.minError?.minValue }}.</span>
                <span class="ce-erro" *ngIf="valorMaximoDescontoProduto.errors?.maxError">Máximo {{ valorMaximoDescontoProduto.errors?.maxError?.maxValue }}.</span>
              </ng-container>
            </span>
            <kendo-numerictextbox class="ce-numero-curto" [attr.type]="'number'" [min]="0.1" [max]="100"
                                  name="valorMaximoDescontoProduto" #valorMaximoDescontoProduto="ngModel"
                                  [format]="obtenhaFormatoPercentual()" [required]="cupom.naoAplicarProdutosComDesconto"
                                  [(ngModel)]="cupom.percentualMaximoDescontoProduto">
            </kendo-numerictextbox>
          </div>
          <label class="ce-opcao ce-opcao--filha" for="permitirComprarComPromocao" *ngIf="cupom.naoAplicarProdutosComDesconto">
            <span class="ce-opcao-texto">
              <b>Aplicar nos outros itens do carrinho</b>
              <small>O desconto vale para os produtos que não estão em promoção.</small>
            </span>
            <input type="checkbox" class="ce-switch" id="permitirComprarComPromocao" name="permitirComprarComPromocao"
                   [(ngModel)]="cupom.permitirComprarComPromocao"/>
          </label>
        </div>
      </section>

      <!-- QUANDO E QUANTO -->
      <section class="ce-painel" [hidden]="secao !== 'quando'">
        <header class="ce-painel-cabecalho">
          <h3>Quando e quanto</h3>
          <p>Até quando, em quais dias e quantas vezes o cupom pode ser usado.</p>
        </header>

        <div class="ce-campo ce-campo--curto">
          <label for="validade">Válido até</label>
          <kendo-datepicker id="validade" name="validade" [format]="'dd/MM/yyyy'" [min]="hoje"
                            placeholder="Sem data limite" [(ngModel)]="cupom.validade">
            <kendo-datepicker-messages today="Hoje" toggle="Alterar data"></kendo-datepicker-messages>
          </kendo-datepicker>
          <span class="ce-dica">Em branco, o cupom não expira.</span>
        </div>

        <div class="ce-campo">
          <span class="ce-rotulo">Dias da semana</span>
          <div class="ce-dias">
            <button type="button" class="ce-dia" *ngFor="let ds of disponibilidadesSemana"
                    [class.selecionado]="ds.disponivel" [attr.aria-pressed]="ds.disponivel"
                    (click)="ds.disponivel = !ds.disponivel">{{ ds.label }}</button>
          </div>
          <span class="ce-dica">{{ algumDiaMarcado() ? 'Só funciona nos dias marcados.' : 'Nenhum marcado: vale todos os dias.' }}</span>
        </div>

        <h4 class="ce-subtitulo">Limite de usos</h4>
        <div class="ce-linha">
          <div class="ce-campo">
            <label for="quantidade">No total</label>
            <kendo-numerictextbox [attr.type]="'number'" id="quantidade" name="quantidade" format="n0" [min]="0"
                                  [(ngModel)]="cupom.quantidade">
            </kendo-numerictextbox>
          </div>
          <div class="ce-campo">
            <label for="qtdeMaxima">Por cliente</label>
            <kendo-numerictextbox [attr.type]="'number'" id="qtdeMaxima" name="qtdeMaxima" format="n0" [min]="0"
                                  [(ngModel)]="cupom.qtdeMaxima">
            </kendo-numerictextbox>
          </div>
        </div>
        <span class="ce-dica ce-dica--solta">Vazio ou 0 = sem limite.</span>
      </section>
    </div>
  </div>

  <footer class="ce-rodape">
    <div class="ce-status">
      <span class="ce-status-erro" role="alert" *ngIf="mensagemErro">
        <i class="fas fa-exclamation-circle"></i> {{ mensagemErro }}
      </span>
      <span class="ce-status-erro" *ngIf="!mensagemErro && frm.submitted && frm.invalid">
        <i class="fas fa-exclamation-circle"></i> Corrija os campos marcados.
      </span>
      <span class="ce-status-ok" *ngIf="mensagemSucesso">
        <i class="fas fa-check-circle"></i> {{ mensagemSucesso }}
      </span>
    </div>
    <button type="button" class="ce-botao ce-botao--fantasma" (click)="fechar()">
      {{ cupom.id ? 'Fechar' : 'Cancelar' }}
    </button>
    <button type="submit" class="ce-botao ce-botao--primario" [disabled]="salvando">
      {{ salvando ? 'Salvando…' : (cupom.id ? 'Salvar alterações' : 'Criar cupom') }}
    </button>
  </footer>
</form>
